import BaseComponent from "../core/base-component.js";

export default class FormWidget extends BaseComponent {
}
